import {Component, OnInit, ViewChild} from '@angular/core';
import {KfReportingService} from '../../../kf-reporting/services/kf-reporting.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Page} from '../../../shared/models/page.interface';
import {Master} from '../../../admin/models/master.interface';
import {PageRequest} from '../../../shared/models/page-request.interface';
import {MatStepper} from '@angular/material/stepper';
import {KfConfigurationService} from '../../services/kf-configuration.service';
import {KFConfiguration} from '../../models/kf-configuration.interface';
import {UnuKeyMapping} from '../../models/unu-key-mapping.interface';
import {KfConfigMappings} from '../../models/kf-config-mapping.interface';
import {MessageService} from '../../../shared/services/message.service';
import {COUNTRY, WEEE_SYSTEM} from '../../../constants/constants';
import {ConfirmDialogComponent} from '../../../shared/components/confirm-dialog/confirm-dialog.component';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-kf-configuration-edit',
  templateUrl: './kf-configuration-edit.component.html',
  styleUrls: ['./kf-configuration-edit.component.scss']
})
export class KfConfigurationEditComponent implements OnInit {

  @ViewChild('stepper')
  stepper!: MatStepper;

  @ViewChild('stepper2')
  stepper2!: MatStepper;

  currentRoute?: string;
  currentStep = 0;
  schemaKind!: string;
  step2Completed = false;
  kfConfiguration!: KFConfiguration;
  allCategories!: Page<Master>;
  allCollectionStreams!: Page<Master>;
  selectedCategories!: Master[];
  selectedCollectionStreams!: Master[];
  categoriesInitialMappingBeforeChanges!: KfConfigMappings;
  firstLoadCategoriesMapping = true;
  categoriesInitialMapping!: KfConfigMappings;
  collectionStreamsInitialMappingBeforeChanges!: KfConfigMappings;
  collectionStreamsInitialMapping!: KfConfigMappings;
  firstLoadCollectionStreamMapping = true;
  unuKeys!: Page<Master>;
  existReuseConfig!: boolean;
  reuseOption = 1;
  yearToReuse = 0;
  previousYears!: number[];

  constructor(private readonly kfConfigurationService: KfConfigurationService,
              private readonly kfReportingService: KfReportingService,
              private readonly messageService: MessageService,
              private readonly activatedRoute: ActivatedRoute,
              private readonly dialog: MatDialog,
              private router: Router) {
    this.currentRoute = router.getCurrentNavigation()?.extractedUrl.toString();
  }

  ngOnInit(): void {
    if (this.currentRoute && this.currentRoute.includes('weeesystem')) {
      this.schemaKind = WEEE_SYSTEM;
    } else if (this.currentRoute && this.currentRoute.includes('country')) {
      this.schemaKind = COUNTRY;
    }
    this.activatedRoute.params.subscribe((params) => {
      this.kfConfigurationService.getByYear(params.year, this.schemaKind).subscribe(data => {
        this.kfConfiguration = data.content;
        this.loadLists();
        this.getCategoryMappings();
        this.getCollectionStreamMappings();
        this.kfConfigurationService.existConfigToReuse(this.kfConfiguration.year, this.schemaKind)
          .subscribe(existsCountryConfig => {
            this.existReuseConfig = existsCountryConfig;
          });
      });
      this.kfConfigurationService.getReportCycleCategories(params.year, {page: 0, size: 5}).subscribe(
        data => this.allCategories = data
      );
      this.kfConfigurationService.getReportCycleCollectionStreams(params.year, {page: 0, size: 5}).subscribe(
        data => this.allCollectionStreams = data
      );
      this.kfConfigurationService.getReportCycleUnuKeys(params.year, {page: 0, size: 1000}).subscribe(
        data => this.unuKeys = data
      );
    });
    this.kfConfigurationService.getPreviousYears(this.schemaKind).subscribe(data => this.previousYears = data.content);
  }

  private loadLists(): void {
    this.kfConfigurationService.getCategoriesByReferenceId(this.kfConfiguration.reportCycleReferenceId).subscribe(
      categories => {
        if (!categories.length) {
          this.messageService.showMessage('No categories configured for the selected year', 'error');
        }
        this.selectedCategories = [];
        this.selectedCategories.push({id: 0, code: 'NS', description: 'Not in scope'} as Master);
        categories.forEach(item => this.selectedCategories.push(item));
      }
    );
    this.kfConfigurationService.getCollectionStreamsByReferenceId(this.kfConfiguration.reportCycleReferenceId).subscribe(
      streams => {
        if (!streams.length) {
          this.messageService.showMessage('No collection streams configured for the selected year', 'error');
        }
        this.selectedCollectionStreams = [];
        this.selectedCollectionStreams.push({id: 0, code: 'NS', description: 'Not in scope'} as Master);
        streams.forEach(item => this.selectedCollectionStreams.push(item));
      }
    );
  }

  loadStep(step: number): void {
    this.currentStep = step;
  }

  loadReportCycleCategories(event: PageRequest): void {
    this.kfConfigurationService.getReportCycleCategories(this.kfConfiguration.year, event).subscribe(
      data => this.allCategories = data
    );
  }

  loadReportCycleCollectionStreams(event: PageRequest): void {
    this.kfConfigurationService.getReportCycleCollectionStreams(this.kfConfiguration.year, event).subscribe(
      data => this.allCollectionStreams = data
    );
  }

  getSelectedCategories(): void {
    this.kfConfigurationService.getCategoriesByReferenceId(this.kfConfiguration.reportCycleReferenceId).subscribe(
      data => {
        this.selectedCategories = [];
        this.selectedCategories.push({id: 0, code: 'NS', description: 'Not in scope'} as Master);
        data.forEach(item => this.selectedCategories.push(item));
      }
    );
  }

  getSelectedCollectionStreams(): void {
    this.kfConfigurationService.getCollectionStreamsByReferenceId(this.kfConfiguration.reportCycleReferenceId).subscribe(
      data => {
        this.selectedCollectionStreams = [];
        this.selectedCollectionStreams.push({id: 0, code: 'NS', description: 'Not in scope'} as Master);
        data.forEach(item => this.selectedCollectionStreams.push(item));
      }
    );
  }


  stepperIndex(stepper: string, index: number): void {
    if (stepper === 'stepper') {
      setTimeout(() => {
        this.stepper.selectedIndex = index;
      });
    }
    if (stepper === 'stepper2') {
      setTimeout(() => {
        this.stepper2.selectedIndex = index;
      });
    }
  }

  addSelectedCategory(id: number): void {
    const updatedConfig = {...this.kfConfiguration};
    if (!updatedConfig.keyFigureCategoriesIds) {
      updatedConfig.keyFigureCategoriesIds = [];
    }
    updatedConfig.keyFigureCategoriesIds.push(id);
    this.kfConfiguration = updatedConfig;
  }

  addSelectedCollectionStream(id: number): void {
    const updatedConfig = {...this.kfConfiguration};
    if (!updatedConfig.collectionStreamIds) {
      updatedConfig.collectionStreamIds = [];
    }
    updatedConfig.collectionStreamIds.push(id);
    this.kfConfiguration = updatedConfig;
  }

  removeSelectedCategory(id: number): void {
    const updatedConfig = {...this.kfConfiguration};
    updatedConfig.keyFigureCategoriesIds = updatedConfig.keyFigureCategoriesIds.filter(item => item !== id);
    this.kfConfiguration = updatedConfig;
  }

  removeSelectedCollectionStream(id: number): void {
    const updatedConfig = {...this.kfConfiguration};
    updatedConfig.collectionStreamIds = updatedConfig.collectionStreamIds.filter(item => item !== id);
    this.kfConfiguration = updatedConfig;
  }

  saveConfig(): void {
    this.kfConfigurationService.saveKfConfiguration(this.kfConfiguration, this.schemaKind).subscribe(data => {
      this.kfConfiguration = data.content;
      this.getSelectedCategories();
      this.getCategoryMappings();
      this.getSelectedCollectionStreams();
      this.getCollectionStreamMappings();
    });
  }

  saveCategoriesMappings(event: UnuKeyMapping[]): void {
    const kfConfigMappings = {
      systemSchemaReferenceId: this.kfConfiguration.reportCycleReferenceId,
      unuKeyMappings: event
    } as KfConfigMappings;
    this.kfConfigurationService.saveKfConfigurationCategoriesMappings(kfConfigMappings, this.schemaKind).subscribe(
      () => {
        this.getSelectedCategories();
        this.getCategoryMappings();
      }
    );
  }

  saveCollectionStreamMappings(event: UnuKeyMapping[]): void {
    const kfConfigMappings = {
      systemSchemaReferenceId: this.kfConfiguration.reportCycleReferenceId,
      unuKeyMappings: event
    } as KfConfigMappings;
    this.kfConfigurationService.saveKfConfigurationCollectionStreamsMappings(kfConfigMappings, this.schemaKind).subscribe(
      () => {
        this.getSelectedCollectionStreams();
        this.getCollectionStreamMappings();
      }
    );
  }

  launchReport(): void {
    this.kfConfigurationService.checkMappings(this.kfConfiguration.reportCycleReferenceId, this.kfConfiguration.year, this.schemaKind)
      .subscribe(validConfig => {
        if (validConfig) {
          const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: {
              item: 'kf-reporting.launch'
            },
            maxWidth: 600
          });
          dialogRef.componentInstance.confirmEvent.subscribe(() => {
            dialogRef.close();
            this.kfConfigurationService.launchConfig(this.kfConfiguration.reportCycleReferenceId, this.schemaKind).subscribe(
              () =>
                this.router.navigate([`/kfdataentry/${this.schemaKind.toLowerCase()}/kfconfiguration`],
                  {state: {message: 'The configuration has been successfully launched'}})
            );

          });
        } else {
          this.messageService.showMessage('The Groups definition step is incomplete. Please check the configuration before launching.', 'error');
        }
      });
  }

  private getCollectionStreamMappings(): void {
    this.kfConfigurationService.getKfConfigurationCollectionStreamsMappings
    (this.kfConfiguration.reportCycleReferenceId, this.schemaKind).subscribe(
      collectionStreamMapping => {
        this.collectionStreamsInitialMapping = collectionStreamMapping.content;

        if (this.firstLoadCollectionStreamMapping) {
          this.collectionStreamsInitialMappingBeforeChanges = collectionStreamMapping.content;
        }
      }
    );
  }

  private getCategoryMappings(): void {
    this.kfConfigurationService.getKfConfigurationCategoriesMappings
    (this.kfConfiguration.reportCycleReferenceId, this.schemaKind).subscribe(
      categoriesMapping => {
        this.categoriesInitialMapping = categoriesMapping.content;

        if (this.firstLoadCategoriesMapping) {
          this.categoriesInitialMappingBeforeChanges = categoriesMapping.content;
        }
      }
    );
  }

  initializeConfig(): void {
    if (this.reuseOption === 1) {
      this.currentStep = 1;
    }
    if (this.reuseOption === 2) {
      this.kfConfigurationService.reuseConfiguration(this.kfConfiguration.year, this.schemaKind).subscribe(data => {
        this.kfConfiguration = data.content;
        this.loadLists();
        setTimeout(() => {
          this.getCategoryMappings();
          this.getCollectionStreamMappings();
          this.firstLoadCategoriesMapping = false;
          this.firstLoadCollectionStreamMapping = false;
        }, 1);
        this.kfConfigurationService.getReportCycleCategories(this.kfConfiguration.year, {page: 0, size: 5}).subscribe(
          categories => {
            this.allCategories = categories;
          }
        );
        this.kfConfigurationService.getReportCycleCollectionStreams(this.kfConfiguration.year, {page: 0, size: 5}).subscribe(
          cs => this.allCollectionStreams = cs
        );
        this.currentStep = 1;
      });
    }
    if (this.reuseOption === 3) {
      if (!this.yearToReuse) {
        this.messageService.showMessage('You must select a year if you want to reuse a previous configuration', 'error');
      } else {
        this.kfConfigurationService.reusePreviousConfiguration(this.kfConfiguration.year, this.yearToReuse, this.schemaKind)
          .subscribe(data => {
            this.kfConfiguration = data.content;
            this.loadLists();
            setTimeout(() => {
              this.getCategoryMappings();
              this.getCollectionStreamMappings();
              this.firstLoadCategoriesMapping = false;
              this.firstLoadCollectionStreamMapping = false;
            }, 1);
            this.kfConfigurationService.getReportCycleCategories(this.kfConfiguration.year, {page: 0, size: 5}).subscribe(
              categories => {
                this.allCategories = categories;
              }
            );
            this.kfConfigurationService.getReportCycleCollectionStreams(this.kfConfiguration.year, {page: 0, size: 5}).subscribe(
              cs => this.allCollectionStreams = cs
            );
            this.currentStep = 1;
          });
      }
    }
  }

}
